import { render, staticRenderFns } from "./MovementsStat.vue?vue&type=template&id=8bf256a6&scoped=true&"
import script from "./MovementsStat.vue?vue&type=script&lang=js&"
export * from "./MovementsStat.vue?vue&type=script&lang=js&"
import style0 from "./MovementsStat.vue?vue&type=style&index=0&id=8bf256a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf256a6",
  null
  
)

export default component.exports